import $ from 'jquery';
import * as requestLib from './requestLib';
import ErrorHandler from '../class/ErrorHandler';

let baseUrl = requestLib.getUrl();
const twoFactorUrl = 'https://2factor.goqual.com/';

export default {
  requestLogin: (url, data, callback, errorCallback = () => {}) => {
    url = 'https://square.hej.so/' + url;
    $.ajax({
      url,
      // data:{},
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          'Authorization',
          'Basic ' + btoa(data.username + ':' + data.password)
        );
        xhr.setRequestHeader(
          'Content-type',
          'application/x-www-form-urlencoded'
        );
        xhr.setRequestHeader('x-requested-with', 'XMLHttpRequest');
        xhr.setRequestHeader('accept-language', 'ko-kr');
      },
      dataType: 'text',
      type: 'post',
      success: function (res) {
        callback(res);
      },
      error: (req, status, err) => {
        errorCallback(req, status, err);
        console.log('error', req, status, err);
      }
    });
  },

  requestAuth: (url, loginData, data, callback, errorCallback = () => {}) => {
    url = baseUrl + url;
    $.ajax({
      url,
      data: data,
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          'Authorization',
          'Basic ' + btoa(loginData.username + ':' + loginData.password)
        );
        xhr.setRequestHeader(
          'Content-type',
          'application/x-www-form-urlencoded'
        );
        xhr.setRequestHeader('x-requested-with', 'XMLHttpRequest');
        xhr.setRequestHeader('accept-language', 'ko-kr');
      },
      dataType: 'json',
      type: 'get',
      success: function (res) {
        callback(res);
      },
      error: (req, status, err) => {
        errorCallback(req, status, err);
        console.log('error', req, status, err);
      }
    });
  },

  requestPostEvent: (url, callback, errorCallback = () => {}) => {
    //url = "https://goqual.io/" + url;
    url =
      'http://masterrabbitmqd5swrzygrtoji-vm0.koreacentral.cloudapp.azure.com/' +
      url;
    $.ajax({
      url,
      type: 'post',
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          'Authorization',
          'Basic ' +
            btoa(
              '62f4020744ca4510827d3b4a4d2c7e7f:fcd4302cece447a9ab009296f649d2c0'
            )
        );
        xhr.setRequestHeader(
          'Content-type',
          'application/x-www-form-urlencoded'
        );
      },
      success: function (res) {
        callback(res);
      },
      error: (req, status, err) => {
        errorCallback(req, status, err);
        console.log('error', req, status, err);
      }
    });
  },

  requestPost: (url, data, callback, errorCallback = () => {}) => {
    url = baseUrl + url;
    $.ajax({
      url,
      data,
      dataType: 'json',
      type: 'post',
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          'Authorization',
          'Basic ' +
            btoa(
              '62f4020744ca4510827d3b4a4d2c7e7f:fcd4302cece447a9ab009296f649d2c0'
            )
        );
        xhr.setRequestHeader(
          'Content-type',
          'application/x-www-form-urlencoded'
        );
      },
      success: function (res) {
        callback(res);
      },
      error: (req, status, err) => {
        errorCallback(req, status, err);
        //console.log('error',req,status,err);
      }
    });
  },

  request2FAPost: (url, data, callback, errorCallback = () => {}) => {
    url = twoFactorUrl + url;
    $.ajax({
      url,
      data,
      type: 'post',
      beforeSend: function (xhr) {
        // xhr.setRequestHeader("Authorization", "Basic " + btoa("62f4020744ca4510827d3b4a4d2c7e7f:fcd4302cece447a9ab009296f649d2c0"));
        xhr.setRequestHeader('Content-Type', 'application/json;charset-UTF-8');
      },
      success: function (res) {
        callback(res);
      },
      error: (req, status, err) => {
        errorCallback(req, status, err);
        //console.log('error',req,status,err);
      }
    });
  },

  requestPostWithToken: (
    url,
    accessToken,
    component,
    callback,
    errorCallback = () => {}
  ) => {
    url = baseUrl + url;
    $.ajax({
      url,
      dataType: 'text',
      type: 'post',
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken);
        xhr.setRequestHeader('Content-Type', 'application/json;charset-UTF-8');
      },
      success: function (res) {
        callback(res);
      },
      error: (req, status, err) => {
        errorCallback(req, status, err);
        //console.log('error',req,status,err);
        new ErrorHandler(component).processError(err);
      }
    });
  },

  requestPostWithData: (
    url,
    accessToken,
    data,
    component,
    callback,
    errorCallback = () => {}
  ) => {
    url = baseUrl + url;
    $.ajax({
      url,
      dataType: 'text',
      type: 'post',
      data: data,
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken);
        xhr.setRequestHeader('Content-Type', 'application/json');
      },
      success: function (res) {
        callback(res);
      },
      error: (req, status, err) => {
        errorCallback(req, status, err);
        //console.log('error',req,status,err);
        new ErrorHandler(component).processError(err);
      }
    });
  },

  requestPutWithData: (
    url,
    accessToken,
    data,
    component,
    callback,
    errorCallback = () => {}
  ) => {
    url = baseUrl + url;
    $.ajax({
      url,
      dataType: 'text',
      type: 'put',
      data: data,
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken);
        xhr.setRequestHeader('Content-Type', 'application/json');
      },
      success: function (res) {
        callback(res);
      },
      error: (req, status, err) => {
        errorCallback(req, status, err);
        //console.log('error',req,status,err);
      }
    });
  },

  requestGetWithToken: (
    url,
    accessToken,
    component,
    callback,
    errorCallback = () => {}
  ) => {
    url = baseUrl + url;
    $.ajax({
      url,
      // data,
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken);
        xhr.setRequestHeader('Content-Type', 'application/json;charset-UTF-8');
      },
      dataType: 'json',
      type: 'get',
      success: res => {
        callback(res);
      },
      error: (req, status, err) => {
        errorCallback(req, status, err);
        new ErrorHandler(component).processError(err);
      }
    });
  },

  requestDelWithToken: (
    url,
    accessToken,
    component,
    callback,
    errorCallback = () => {}
  ) => {
    url = baseUrl + url;
    $.ajax({
      url,
      // data,
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken);
        xhr.setRequestHeader('Content-Type', 'application/json;charset-UTF-8');
      },
      dataType: 'json',
      type: 'delete',
      success: res => {
        callback(res);
      },
      error: (req, status, err) => {
        errorCallback(req, status, err);
        //console.log(req, status, err)
      }
    });
  },

  requestGet: (url, data, callback, errorCallback = () => {}) => {
    url = baseUrl + url;
    $.ajax({
      url,
      data,
      beforeSend: function (xhr) {
        // xhr.setRequestHeader("Authorization", "Basic " + btoa(loginData.username + ":" + loginData.password));
      },
      dataType: 'json',
      type: 'get',
      success: res => {
        callback(res);
      },
      error: (req, status, err) => {
        errorCallback(req, status, err);
        //console.log(req, status, err)
      }
    });
  },

  getQueryString: (name, url) => {
    if (!url) url = window.location.href;
    // eslint-disable-next-line
    name = name.replace(/[\[\]]/g, '\\$&');
    // eslint-disable-next-line
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);

    if (!results) return null;
    if (!results[2]) return '';
    // eslint-disable-next-line
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  getCookie: name => {
    let value = '; ' + document.cookie;
    let parts = value.split('; ' + name + '=');
    if (parts.length === 2) return parts.pop().split(';').shift();
  },

  getDate: timestamp => {
    // noinspection UnnecessaryLocalVariableJS
    var d = new Date(timestamp * 1000),
      yyyy = d.getFullYear(),
      mm = ('0' + (d.getMonth() + 1)).slice(-2), // Months are zero based. Add leading 0.
      dd = ('0' + d.getDate()).slice(-2), // Add leading 0.
      time = yyyy + '.' + mm + '.' + dd;
    return time;
  }
};
